import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, watch, PropType } from 'vue';
import FormFlowWrapper from '../common/form/FormFlowWrapper.vue';
import { BrandingImageType } from 'ah-api-gateways';
import PeopleWavingIcon from 'ah-common-lib/src/icons/components/PeopleWavingIcon.vue';
import HeadquartersIcon from 'ah-common-lib/src/icons/components/HeadquartersIcon.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'RegistrationTypeSelection',
  props: {
  selected: {
    type: String as PropType<'' | 'company' | 'personal'>,
    required: true,
  },
},
  emits: {
  'update:selected': (_value: 'company' | 'personal' | '') => true,
},
  setup(__props, { emit }) {

const props = __props;





const selection = ref<'company' | 'personal' | ''>('');

const select = (newSelection: 'company' | 'personal') => {
  selection.value = selection.value === newSelection ? '' : newSelection;
};

const splashLogoLink = computed(() => {
  return (globalThis as any).$theme?.val?.logos.find((l: any) => l.type === BrandingImageType.SPLASH_IMAGE)?.link;
});

const updateSelected = () => {
  emit('update:selected', selection.value);
};

const isSmallScreen = computed(() => {
  return (globalThis as any).$mediaQuery?.is('mdDown');
});

watch(
  () => props.selected,
  (newValue) => {
    if (newValue === 'company' || newValue === 'personal' || newValue === '') {
      selection.value = newValue;
    } else {
      selection.value = '';
    }
  },
  { immediate: true }
);

return { __sfc: true,props, emit, selection, select, splashLogoLink, updateSelected, isSmallScreen, FormFlowWrapper, PeopleWavingIcon, HeadquartersIcon }
}

})